import { useState } from 'react';
import { AxiosErrorHandler, Card, Col, InfinityLoading, Loading, Row, Text } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { ProgramLayout } from 'features/programs/program-layout';
import { useProgramMembersInfiniteQuery } from '../queries';
import { MemberRow } from './member-row';
import { MembersHeader, type ProgramMembersSortBy } from './members-header';

type P = {
  programId: string;
};

const ProgramMembers = ({ programId }: P) => {
  const [sortBy, setSortBy] = useState<ProgramMembersSortBy>('name');

  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useProgramMembersInfiniteQuery({
    filter: { programId, sort: sortBy },
    pagination: { pageSize: 10 },
  });

  const members = data?.pages.flatMap((page) => page.users);

  const joinedCount = data?.pages.at(0)?.joinedCount ?? 0;
  const pendingCount = data?.pages.at(0)?.pendingCount ?? 0;

  const onSorting = (key: ProgramMembersSortBy) => {
    setSortBy(key);
  };

  return (
    <AxiosErrorHandler error={error}>
      <ProgramLayout programId={programId}>
        {(program) => (
          <Card
            title={
              <MembersHeader
                joinedCount={joinedCount}
                onSort={onSorting}
                pendingCount={pendingCount}
                program={program}
                sortBy={sortBy}
              />
            }
          >
            {members ? (
              <Row gutter={[0, 'md']} justify="center">
                <Col span={24}>
                  {members.map((member) => (
                    <MemberRow key={member.id} member={member} programId={programId} programName={program.name} />
                  ))}
                </Col>
                {!hasNextPage && !isFetchingNextPage ? (
                  <Col>
                    <Text>You are at the end of the list. There are no more users to be loaded.</Text>
                  </Col>
                ) : null}
              </Row>
            ) : (
              <Loading />
            )}
            <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetchingNextPage} onEnter={fetchNextPage} />
          </Card>
        )}
      </ProgramLayout>
    </AxiosErrorHandler>
  );
};

export default ProgramMembers;
